import 'es6-promise/auto';
import 'babel-polyfill';
import '@fortawesome/fontawesome-free/css/all.css';
import 'material-design-icons-iconfont/dist/material-design-icons.css';
import './vueFilters';
import Vue from 'vue';
import '@aspnet/signalr';
import VeeValidate from 'vee-validate';
import Vuetify from 'vuetify';
import $ from 'jquery';
import FormMixin from './mixins/FormMixins';
window.jQuery = $;
window.$ = $;

Vue.config.productionTip = false;
Vue.use(Vuetify, {
  theme: {
    primary: '#252525',
    secondary: '#11009A',
    accent: '#990101',
  },
});
Vue.use(VeeValidate);
Vue.mixin(FormMixin);

const areaFiles = require.context('~/Areas', true, /\.vue$/i);
const resourceFiles = require.context('~/Resources', true, /\.vue$/i);

// eslint-disable-next-line
areaFiles.keys().map((key) => {
  const component = areaFiles(key).default;
  if (component.parent) {
    Vue.component(key.split('/').pop().split('.')[0], areaFiles(key).default);
  }
});

// eslint-disable-next-line
resourceFiles.keys().map((key) => {
  const component = resourceFiles(key).default;
  if (component.parent) {
    Vue.component(key.split('/').pop().split('.')[0], resourceFiles(key).default);
  }
});

new Vue().$mount('#app');

$('#loadCover').remove();